import React from "react";
import { Button, ButtonProps } from "antd";
import { useTranslation } from "react-i18next";

import styles from "./index.module.scss";

/**
 * Deleting something, wherever a screen offers it: an edit page, a preview, a
 * drawer.
 *
 * The whole rule in one place, because it is a rule and not a decision to make
 * again on each screen. Always visible — never folded into an ellipsis, where
 * the one action that cannot be taken back is the one found by accident. First
 * in its group. Outlined danger: marked, without competing with the primary at
 * the other end of the row. No icon; the word is the word.
 *
 * And held 24px off whatever follows it, which is three times the space the
 * other buttons keep between themselves — the hand reaching for Save should
 * have to travel to reach this. The margin here is 16 because a group of
 * buttons is spaced by 8, and the two together are the 24.
 */
export default function DeleteButton({ children, ...props }: ButtonProps) {
  const { t } = useTranslation();

  return (
    <Button danger className={styles.button} {...props}>
      {children ?? t("common.delete")}
    </Button>
  );
}
